export default __webpack_public_path__ + "static/media/edge.137e3ff4.svg";